const EDITABLE_TAGS = /^(INPUT|TEXTAREA|SELECT|OPTION|BUTTON)$/;

let dndDraggableSelectionFix = () => {
    return {
        restrict: 'A',
        link: (scope, element) => {
            element.on('mousedown', (event) => {
                if (event.button !== 0 || event.shiftKey) return;

                const target = event.target;
                if (!target || EDITABLE_TAGS.test(target.tagName) || target.isContentEditable) return;

                const selection = window.getSelection && window.getSelection();
                if (selection && !selection.isCollapsed) selection.removeAllRanges();
            });
        }
    };
};

export default dndDraggableSelectionFix;



// WEBPACK FOOTER //
// ./client/app/common/dnd-fix/dnd-fix.directive.js